import { TDescriptionValue } from 'shared/types/typographyComponents';

export const LIST: TDescriptionValue[][] = [
  [
    {
      value: 'Мой дом',
      isBold: true,
    },
    {
      value:
        ' показывает рыночную стоимость объекта и динамику цен, помогает сравнить с аналогами и оценить ликвидность',
    },
  ],
  [
    {
      value: 'Циан.Оценка',
      isBold: true,
    },
    {
      value:
        ' для агентов рассчитывает рыночную стоимость жилья на основе анализа базы объявлений и формирует отчёт с прогнозом экспозиции, делая работу с недвижимостью прозрачнее и эффективнее',
    },
  ],
  [
    {
      value: 'Циан.API',
      isBold: true,
    },
    {
      value:
        ' позволяет агентствам и застройщикам интегрировать личный кабинет с CRM-системой, автоматизируя работу с объявлениями, статистикой, заявками и бюджетом — для более точного контроля и эффективного управления бизнесом',
    },
  ],
];
